import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { RootState } from 'src/features';

// UserStateのlanguageが解決していない場合にBlancoの再起動を促す
export const CheckLanguageSetup: React.FC = ({ children }) => {
  const language = useSelector((state: RootState) => state.user.language);
  if (language) {
    return <>{children}</>;
  } else {
    return <Redirect to="/restart-required" />;
  }
};
